import styled from "styled-components";

export const LoginActionButtons = styled.div(props => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "32px 0",
    ...props,
  }))
  